import { ForkEffect, takeEvery } from 'redux-saga/effects';
import { Socket } from 'socket.io-client';

import { send } from '../send-request';
import {
  facebookActiveNetworksLoad,
  facebookHistoryLoad,
  facebookScoredProductsLoad,
  facebookSuggestionLoad,
  facebookSuggestionPublish,
  facebookSuggestionSkip,
} from './reducer';

export function* watch(
  socket: Socket,
): Generator<ForkEffect<never>, void, string> {
  yield takeEvery(facebookActiveNetworksLoad.type, send, socket);
  yield takeEvery(facebookSuggestionLoad.type, send, socket);
  yield takeEvery(facebookSuggestionPublish.type, send, socket);
  yield takeEvery(facebookSuggestionSkip.type, send, socket);
  yield takeEvery(facebookHistoryLoad.type, send, socket);
  yield takeEvery(facebookScoredProductsLoad.type, send, socket);
}
